export function generateId(): string {
  return Math.random().toString(36).substring(2, 11);
}

export function escapeHtml(text: string): string {
  if (typeof text !== 'string') return '';
  const map: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
  };
  return text.replace(/[&<>"']/g, (m) => map[m]);
}

